<script setup lang="ts">
import type { PropType } from 'vue';

import type { CookieItem } from '~/types/content/cookieItem.type';

const { tt } = useTypedI18n();

defineProps({
    items: { type: Object as PropType<CookieItem[]>, required: true },
});
</script>

<template>
    <table class="block border-collapse border-t md:table md:border-none">
        <thead class="hidden md:table-header-group">
            <tr class="border-b border-solid border-black">
                <th class="p-1 align-top">{{ tt('cookie.name') }}</th>
                <th class="p-1 align-top">{{ tt('cookie.provider') }}</th>
                <th class="p-1 align-top">{{ tt('cookie.purpose') }}</th>
                <th class="p-1 align-top">{{ tt('cookie.expiry') }}</th>
                <th class="p-1 align-top">{{ tt('cookie.type') }}</th>
            </tr>
        </thead>
        <tbody v-for="item in items" :key="item.name" class="block md:table-row-group">
            <tr class="block border-b border-solid border-black md:table-row">
                <td class="block p-1 align-top md:table-cell">
                    <span class="inline-block w-1/4 align-top font-bold md:hidden">{{ tt('cookie.name') }}</span>
                    <span class="inline-block w-3/4">{{ item.name }}</span>
                </td>
                <td class="block p-1 align-top md:table-cell">
                    <span class="inline-block w-1/4 align-top font-bold md:hidden">{{ tt('cookie.provider') }}</span>
                    <span class="inline-block w-3/4">{{ item.provider }}</span>
                </td>
                <td class="block p-1 align-top md:table-cell">
                    <span class="inline-block w-1/4 align-top font-bold md:hidden">{{ tt('cookie.purpose') }}</span>
                    <span class="inline-block w-3/4">{{ item.purpose }}</span>
                </td>
                <td class="block p-1 align-top md:table-cell">
                    <span class="inline-block w-1/4 align-top font-bold md:hidden">{{ tt('cookie.expiry') }}</span>
                    <span class="inline-block w-3/4">{{ item.expiry }}</span>
                </td>
                <td class="block p-1 align-top md:table-cell">
                    <span class="inline-block w-1/4 align-top font-bold md:hidden">{{ tt('cookie.type') }}</span>
                    <span class="inline-block w-3/4">{{ item.type }}</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>
